function addSectionClasses() {
  document.querySelectorAll('.shopify-section').forEach((el, i) => {
    // Remove old ss-* classes first
    el.className = el.className.replace(/\bss-\d+\b/g, '');
    // Add new
    el.classList.add(`ss-${i + 1}`);
  });
}

// Run when DOM is ready
document.addEventListener('DOMContentLoaded', addSectionClasses);

// Also run again when Shopify dynamically updates sections
document.addEventListener('shopify:section:load', addSectionClasses);
document.addEventListener('shopify:section:reorder', addSectionClasses);
document.addEventListener('shopify:section:select', addSectionClasses);
document.addEventListener('shopify:section:deselect', addSectionClasses);
